import { normalizeTime } from './components/Schedule/schedule';

export function dispatchSchedule(dispatch) {
  const slots = dispatch?.offered_slots;
  if (Array.isArray(slots) && slots.length) return slots.map(slot => ({date: slot.date, ...normalizeTime(slot)}));
  return (dispatch?.offered_dates || []).map(date => ({date, ...normalizeTime({time_from: dispatch.offered_time_from, time_to: dispatch.offered_time_to})}));
}
export function dispatchDay(dispatch, day) { return dispatchSchedule(dispatch).find(slot => slot.date === day); }

export const dispatchLabels = {
  unassigned: 'Рассылка остановлена', broadcasting: 'Сбор откликов',
  awaiting_confirmation: 'Ждём подтверждения обмерщика', assigned: 'Обмерщик назначен',
  reassign_needed: 'Нужно перераспределить',
};
export const responseLabels = {
  pending: 'Ждёт решения', accepted_by_manager: 'Выбран', confirmed: 'Подтверждён',
  declined: 'Отказался / истёк срок', withdrawn: 'Отозван / неактуален',
};
export function arrivalError(dispatch, day, time) {
  const slot = dispatchDay(dispatch, day);
  if (!slot) return 'Выберите предложенную дату';
  if (!/^\d{2}:\d{2}$/.test(time)) return 'Укажите точное время прибытия';
  const [hours, minutes] = time.split(':').map(Number);
  if (hours > 23 || minutes > 59) return 'Некорректное время';
  const from = slot.time_from;
  const to = slot.time_to;
  if (slot.mode === 'exact' && time !== from) return `В этот день нужно прибыть в ${from}`;
  if (slot.mode === 'window' && (!from || !to || time < from || time > to)) return 'Время должно быть внутри интервала выбранного дня';
  return '';
}
export function isOwnSurvey(event, account) {
  const owner = typeof event?.employee === 'object' ? event.employee?.id : event?.employee;
  return owner != null && account?.id != null && String(owner) === String(account.id);
}
export function canWorkSurvey(event, account) {
  return isOwnSurvey(event, account) && !event?.is_completed
    && ['measuring_premises', 'additional_measuring'].includes(event?.state);
}
export function responseArrival(response) {
  if (!response?.arrival_time) return 'Старый интервал — требуется новый отклик с точным временем';
  return `${response.chosen_date?.split('-').reverse().join('.')} в ${response.arrival_time.slice(0, 5)}`;
}
export function dispatchError(value) {
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.map(dispatchError).join('; ');
  if (value && typeof value === 'object') return Object.values(value).map(dispatchError).filter(Boolean).join('; ');
  return '';
}

export function formatDispatchInstant(value, zone) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Дата не указана';
  try { return date.toLocaleString('ru-RU', { timeZone: zone || 'UTC' }); }
  catch (_) { return `${date.toISOString()} (UTC)`; }
}
export function arrivalReady(event) {
  return event?.arrival ? Boolean(event.arrival.ready) : Boolean(event?.arrived_at);
}
export function canCompleteSurvey(event, account) {
  return canWorkSurvey(event, account) && arrivalReady(event);
}
